<template>
  <div>
    <el-divider class="pcb-form__divider" content-position="center">FR-4 基本信息</el-divider>
    <!-- 板子层数 -->
    <blayer v-model="pcbParams.blayer" :blind="pcbParams.blind" :initPcbParamsChange="initPcbParamsChange" />
    <!-- HDI(盲埋孔) -->
    <blind v-model="pcbParams.blind" :blayer="pcbParams.blayer" :initPcbParamsChange="initPcbParamsChange" />
    <!-- 板材 -->
    <board 
      ref="board"
      :board_brand.sync="pcbParams.board_brand" 
      :board_tg.sync="pcbParams.board_tg" 
      :board_model.sync="pcbParams.board_model" 
      :params="{
        blayer: pcbParams.blayer,
        blind: pcbParams.blind,
        bheight: pcbParams.bheight,
        copper: pcbParams.copper,
        insidecopper: pcbParams.insidecopper
      }"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 拼板款数 -->
    <pbnum ref="pbnum" v-model="pcbParams.pbnum" />
    <!-- 出货形式 -->
    <units 
      v-model="pcbParams.units" 
      :bcount="pcbParams.bcount" 
      :length="pcbParams.length" 
      :width="pcbParams.width" 
      :isSmt="true"
      @open="handleOpenBoardDialog"
      @reset="handleResetBoard"
    />
    <!-- 连片类型 -->
    <delivery_sub_units 
      v-if="isShow.delivery_sub_units"
      ref="delivery_sub_units"
      v-model="pcbParams.delivery_sub_units" 
    />
    <!-- 尺寸 -->
    <length 
      ref="length" 
      :length.sync="pcbParams.length" 
      :width.sync="pcbParams.width" 
      :units="pcbParams.units" 
      :disabled="isDisabledBoardParams"
    />
    <!-- 拼板规则 -->
    <layout
      ref="layout"
      v-if="isShow.layout"
      :layoutx.sync="pcbParams.layoutx"
      :layouty.sync="pcbParams.layouty"
      :form="pcbParams"
      :pcsNum="pcsNumForSet"
      :exampleData="{
        setlength: computePcbSize.length,
        setwidth: computePcbSize.width,
        length: pcbParams.length,
        width: pcbParams.width,
        layouty: pcbParams.layouty,
        layoutx: pcbParams.layoutx,
        bcount: pcbParams.bcount,
        pcsNum: pcsNumForSet,
        m: pcbPrice.m
      }"
      :disabled="isDisabledBoardParams"
    />
    <!-- 数量 -->
    <bcount 
      ref="bcount"
      v-model="pcbParams.bcount" 
      :blayer="pcbParams.blayer" 
      :units="pcbParams.units" 
      :setlength="computePcbSize.length"
      :setwidth="computePcbSize.width"
      :pcsNum="pcsNumForSet" 
      :area="pcbPrice.m"
      :ladderPriceData="{
        blayer: pcbParams.blayer,
        length: computePcbSize.length,
        width: computePcbSize.width,
        bcount: pcbParams.bcount,
        bheight: pcbParams.bheight
      }"
    />
    <!-- 工艺边框 -->
    <sidewidth 
      ref="sidewidth" 
      v-if="isShow.sidewidth" 
      :sidedirection.sync="pcbParams.sidedirection" 
      :sidewidth.sync="pcbParams.sidewidth" 
      :disabled="isDisabledBoardParams"
      :isSmt="true"
    />

    <el-divider class="pcb-form__divider" content-position="center">FR-4 工艺信息</el-divider>
    <!-- 板子厚度-->
    <bheight
      v-model="pcbParams.bheight"
      :blayer="pcbParams.blayer"
      :copper="pcbParams.copper"
      :insidecopper="pcbParams.insidecopper"
      :color="pcbParams.color"
      :bankong="pcbParams.bankong"
      :baobian="pcbParams.baobian"
      :area="area"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 外层铜厚 -->
    <copper 
      v-model="pcbParams.copper" 
      :blayer="pcbParams.blayer" 
      :blind="pcbParams.blind"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 内层铜厚 -->
    <insidecopper 
      ref="insidecopper"
      v-if="isShow.insidecopper"
      v-model="pcbParams.insidecopper" 
      :blayer="pcbParams.blayer" 
      :blind="pcbParams.blind" 
      :copper="pcbParams.copper" 
      :bheight="pcbParams.bheight"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 最小线宽/线距 -->
    <lineweight
      v-model="pcbParams.lineweight"
      :blind="pcbParams.blind"
      :blayer="pcbParams.blayer"
      :copper="pcbParams.copper"
      :insidecopper="pcbParams.insidecopper"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <div class="quote-container__multicolumn">
      <!-- 最小孔径-->
      <vias
        v-model="pcbParams.vias"
        :blind="pcbParams.blind"
        :blayer="pcbParams.blayer"
        :bheight="pcbParams.bheight"
        :copper="pcbParams.copper"
        :insidecopper="pcbParams.insidecopper"
        :color="pcbParams.color"
        :area="area"
        :initPcbParamsChange="initPcbParamsChange" 
      />
      <!-- 孔密度 -->
      <!-- <zknum v-model="pcbParams.zknum" /> -->
    </div>
    <!-- 阻焊颜色-->
    <color
      v-model="pcbParams.color"
      :blayer="pcbParams.blayer"
      :bheight="pcbParams.bheight"
      :copper="pcbParams.copper"
      :vias="pcbParams.vias"
      :area="area"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 字符颜色 -->
    <charcolor 
      v-model="pcbParams.charcolor" 
      :color="pcbParams.color" 
      :initPcbParamsChange="initPcbParamsChange"
    />
    <!-- 阻焊覆盖-->
    <cover
      v-model="pcbParams.cover"
      :blayer="pcbParams.blayer"
      :copper="pcbParams.copper"
      :insidecopper="pcbParams.insidecopper"
      :spray="pcbParams.spray"
      :via_in_pad="pcbParams.via_in_pad"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 盘中孔-->
    <via_in_pad
      v-model="pcbParams.via_in_pad"
      :blayer="pcbParams.blayer"
      :copper="pcbParams.copper"
      :insidecopper="pcbParams.insidecopper"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 表面处理-->
    <spray
      ref="spray"
      v-model="pcbParams.spray"
      :blayer="pcbParams.blayer"
      :bankong="pcbParams.bankong"
      :baobian="pcbParams.baobian"
      :initPcbParamsChange="initPcbParamsChange"
    />
    <!-- 沉金厚度 -->
    <cjh 
      v-if="isShow.cjh" 
      v-model="pcbParams.cjh" 
      :manufacture="pcbPrice.manufacture" 
      :initPcbParamsChange="initPcbParamsChange"
    />
    <!-- 层压顺序 -->
    <overlay_type
      ref="overlay_type"
      v-if="isShow.overlay_type"
      :overlay_type.sync="pcbParams.overlay_type"
      :overlay_seq.sync="pcbParams.overlay_seq"
    />
    <!-- 阻抗 -->
    <impendance 
      v-model="pcbParams.impendance" 
      :copper="pcbParams.copper" 
      :pressing="pcbParams.pressing"
      :initPcbParamsChange="initPcbParamsChange"
    />
    <!-- 叠层结构 -->
    <pressing 
      ref="pressing"
      v-if="isShow.pressing" 
      v-model="pcbParams.pressing" 
      :params="{ 
        blayer: pcbParams.blayer, 
        bheight: pcbParams.bheight, 
        copper: pcbParams.copper, 
        insidecopper: pcbParams.insidecopper, 
        hdi: pcbParams.blind 
      }"
      :pressingData="pcbParams.pressing_data"
    />
    <!-- 手指斜边 -->
    <beveledge ref="beveledge" v-model="pcbParams.beveledge" :pcb-size="computePcbSize" />
    <!-- 半孔 -->
    <bankong 
      v-model="pcbParams.bankong" 
      :blayer="pcbParams.blayer"
      :press_fit_hole="isShow.press_fit_hole ? pcbParams.press_fit_hole : 0"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 包边 -->
    <baobian 
      v-model="pcbParams.baobian" 
      :blayer="pcbParams.blayer"
      :press_fit_hole="isShow.press_fit_hole ? pcbParams.press_fit_hole : 0"
      :initPcbParamsChange="initPcbParamsChange"  
    />
    <!-- 压接孔 -->
    <press_fit_hole 
      ret="press_fit_hole"
      v-if="isShow.press_fit_hole"
      v-model="pcbParams.press_fit_hole" 
      :spray="pcbParams.spray"
      :bankong="pcbParams.bankong"
      :baobian="pcbParams.baobian"
      :initPcbParamsChange="initPcbParamsChange"  
    />

    <el-divider class="pcb-form__divider" content-position="center">FR-4 服务信息</el-divider>
    <!-- 测试方式 -->
    <test v-model="pcbParams.test" :testOptions="pcbPrice.suggest ? pcbPrice.suggest.test : []" />
    <!-- 确认生产稿 -->
    <review_file 
      ref="review_file" 
      v-model="pcbParams.review_file" 
      :blayer="pcbParams.blayer"
      :user_stamp="pcbParams.user_stamp"
      :panelize_method="pcbParams.panelize_method"
      :initPcbParamsChange="initPcbParamsChange" 
      :isShowSmtTips="true"
    />
    <!-- 产品报告 -->
    <report 
      v-model="pcbParams.report" 
      :blayer="pcbParams.blayer" 
      :impendance="pcbParams.impendance"
      :initPcbParamsChange="initPcbParamsChange" 
    />
    <!-- 报告形式 -->
    <report_type ref="report_type" v-if="isShow.report_type" v-model="pcbParams.report_type" />
    <!-- 打叉板 -->
    <cross_board v-model="pcbParams.cross_board" />
    <!-- 隔白纸 -->
    <paper ref="paper" v-model="pcbParams.paper" :length="pcbParams.length" :width="pcbParams.width" />
    <!-- 客编 -->
    <user_stamp ref="user_stamp" v-model="pcbParams.user_stamp" />
    <!-- 产品标签 -->
    <!-- 自定义标签暂时隐藏 -->
    <inner_box_label 
      ref="inner_box_label"
      :inner_box_label.sync="pcbParams.inner_box_label" 
      :custom_id.sync="pcbParams.custom_id" 
      :custom_name.sync="pcbParams.custom_name" 
    />
    <!-- 订单支付方式 -->
    <deduct_type 
      ref="deduct_type"
      :deduct_type.sync="pcbParams.deduct_type" 
      :deduct_limit.sync="pcbParams.deduct_limit" 
      :price-total="pcbPrice.webpay"
    />
    <!-- 品质赔付方式 -->
    <insurance_type 
      :insurance_type.sync="pcbParams.insurance_type" 
      :insurance.sync="pcbParams.insurance" 
      :pcbParams="pcbParams"
    />

    <!-- 拼板工具弹框 -->
    <BoardDialog 
      ref="BoardDialogRef" 
      :pcbParams="pcbParams" 
      @confirm="handleBoardConfirm"
      @cancel="handleBoardCancel"
    />
  </div>
</template>

<script>
// 拼板工具弹框
import BoardDialog from '@@/views/pcb/components/boardDialog/index'

import { scrollTop } from '@@/utils/pageScroll'
import { FR4_DEFAULT_FORM, FR4_BOARD_DEFAULT_FORM } from '@@/utils/defaultForm'
import { isShowPcbParams, computePcbSize } from '@@/utils/pcbParamsFormat'

// 自动注册 pcb fields 文件夹下的订单字段组件
const requireFields = require.context('../../pcb/fields', true, /\.vue$/)
let fieldsComponents = {}
requireFields.keys().forEach(fileName => {
  let component = requireFields(fileName)
  fieldsComponents[fileName.replace(/^\.\/(.*)\.\w+$/, '$1')] = component.default
})

export default {
  props: {
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ...fieldsComponents,
    BoardDialog
  },
  inject: {
    pcbParams: { default: { ...FR4_DEFAULT_FORM } },
    getPcbPrice: { default: () => ({}) }
  },
  computed: {
    // 获取实时的计价数据
    pcbPrice() {
      return this.getPcbPrice()
    },
    // 板子面积
    area() {
      return (this.pcbPrice.m || 0) / 10000
    },
    // 相关字段是否显示判断
    isShow() {
      return isShowPcbParams(this.pcbParams)
    },
    // 计算板子尺寸
    computePcbSize() {
      return computePcbSize(this.pcbParams)
    },
    // 连片数量换算为单片数量
    pcsNumForSet() {
      const { layoutx, layouty, bcount } = this.pcbParams
      return layoutx * layouty * bcount || 0
    },
    // 是否禁用拼板工具相关参数
    isDisabledBoardParams() {
      // 出货形式是 连片(华秋代拼) 时，需要禁用拼板工具相关的参数
      return this.pcbParams.units == 2
    }
  },
  methods: {
    scrollIntoView(key) {
      if (this.$refs[key]) {
        // 滚动到元素上面偏移50px的位置
        const top = this.$refs[key].$el.getBoundingClientRect().top
        scrollTop(top, -50)
      }
    },
    validate(data) {
      data.forEach((item, index) => {
        const ref = this.$refs[item.key]
        if (ref && ref.isShowError) {
          // 显示错误提示样式
          ref.isShowError(true, index === 0)
        }
      })
      const fristItem = data[0]
      this.$message.closeAll()
      this.$message({
        type: 'error',
        offset: 400,
        message: fristItem.tips
      })
      this.scrollIntoView(fristItem.key)
    },

    // 显示拼板工具弹框
    handleOpenBoardDialog(preUnits) {
      this.$refs.BoardDialogRef.open(preUnits ? { units: preUnits } : {})
    },
    // 拼板工具弹框保存
    handleBoardConfirm(data) {
      this.pcbParams = Object.assign(this.pcbParams, { ...data, units: 2 })
    },
    // 拼板工具弹框取消
    handleBoardCancel(preData) {
      this.pcbParams = Object.assign(this.pcbParams, preData || {})
    },
    // 重置拼板工具相关参数
    handleResetBoard() {
      // 重置时，不重置的字段
      const { topImage, botImage, length, width } = this.pcbParams
      this.pcbParams = Object.assign(this.pcbParams, FR4_BOARD_DEFAULT_FORM, { topImage, botImage, length, width })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>